import React from 'react';
import { Page, PageHeader, Section } from '../components/layout/primitives';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Select } from '../components/ui/Select';

/**
 * Reports Page Component
 * 
 * Reports and data export page
 * 
 * @returns {JSX.Element} Reports page component
 */
export const Reports: React.FC = () => {
  return (
    <Page contentClassName="py-6">
      <PageHeader
        className="py-0"
        title="Reports"
        subtitle="Generate and download reports for your platform data."
      />

      <Section className="py-6">
        <div className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Card title="Generate Report">
            <div className="space-y-4">
              <Select
                label="Report Type"
                options={[
                  { label: 'User Activity Report', value: 'user-activity' },
                  { label: 'Performance Report', value: 'performance' },
                  { label: 'Financial Report', value: 'financial' },
                  { label: 'System Health Report', value: 'system-health' },
                ]}
              />
              <Select
                label="Date Range"
                options={[
                  { label: 'Last 7 days', value: '7d' },
                  { label: 'Last 30 days', value: '30d' },
                  { label: 'Last 90 days', value: '90d' },
                  { label: 'Custom range', value: 'custom' },
                ]}
              />
              <Button className="w-full">Generate Report</Button>
            </div>
          </Card>

          <Card title="Recent Reports">
            <div className="space-y-3">
              <div className="flex items-center justify-between rounded-lg bg-agentic-gray-50 p-3">
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium text-agentic-text-primary">User Activity Report</p>
                  <p className="text-xs text-agentic-text-secondary">Generated 2 hours ago</p>
                </div>
                <Button variant="ghost" size="sm">Download</Button>
              </div>
              <div className="flex items-center justify-between rounded-lg bg-agentic-gray-50 p-3">
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium text-agentic-text-primary">Performance Report</p>
                  <p className="text-xs text-agentic-text-secondary">Generated 1 day ago</p>
                </div>
                <Button variant="ghost" size="sm">Download</Button>
              </div>
              <div className="flex items-center justify-between rounded-lg bg-agentic-gray-50 p-3">
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium text-agentic-text-primary">Financial Report</p>
                  <p className="text-xs text-agentic-text-secondary">Generated 3 days ago</p>
                </div>
                <Button variant="ghost" size="sm">Download</Button>
              </div>
            </div>
          </Card>
        </div>

        <Card title="Report Templates">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            <div className="rounded-lg border border-agentic-gray-200 p-4 transition-colors hover:border-kv-agentic-blue">
              <h3 className="mb-2 font-medium text-agentic-text-primary">Monthly Summary</h3>
              <p className="mb-3 text-sm text-agentic-text-secondary">Comprehensive monthly overview</p>
              <Button variant="ghost" size="sm">Use Template</Button>
            </div>
            <div className="rounded-lg border border-agentic-gray-200 p-4 transition-colors hover:border-kv-agentic-blue">
              <h3 className="mb-2 font-medium text-agentic-text-primary">Quarterly Review</h3>
              <p className="mb-3 text-sm text-agentic-text-secondary">Quarterly performance analysis</p>
              <Button variant="ghost" size="sm">Use Template</Button>
            </div>
            <div className="rounded-lg border border-agentic-gray-200 p-4 transition-colors hover:border-kv-agentic-blue">
              <h3 className="mb-2 font-medium text-agentic-text-primary">Custom Report</h3>
              <p className="mb-3 text-sm text-agentic-text-secondary">Build your own report</p>
              <Button variant="ghost" size="sm">Create New</Button>
            </div>
          </div>
        </Card>
      </Section>
    </Page>
  );
};
